// src/routes/UnauthenticatedRoutes.js

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom"; // Import Navigate
// Import all page components rendered within unauthenticated routes
import LoginPage from "../components/Auth/LoginPage";
import SignupPage from "../components/Auth/SignupPage";
// import ForgotPasswordPage from "../components/Auth/ForgotPasswordPage"; // REMOVED: Handled by AppContent top-level route
import WelcomePage from "../components/WelcomePage"; // Assuming this is the default unauthenticated home



// This component contains the <Routes> and <Route> definitions for all paths
// accessible to unauthenticated users. AppContent.js ensures
// this component is only rendered when the user is not authenticated.
const UnauthenticatedRoutes = () => {
    // Note: AppContent.js's outer logic acts as the primary guard.
    // Components rendered here *can* assume the user is NOT authenticated.

    return (
        <Routes> {/* Nested Routes for the unauthenticated area */}
            {/* Define specific routes for unauthenticated users */}
            <Route path="/" element={<WelcomePage />} /> {/* Default home page for unauthenticated users */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            {/* REMOVED: Forgot Password route - Handled by AppContent top-level route
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            */}

            {/* Optional: Catch-all within unauthenticated area for unmatched paths */}
            {/* If a user is not logged in and tries to access an unknown path (except /forgot-password) */}
            {/* Redirect them to the login page, or the unauthenticated home page, or show a 404 */}
            {/*<Route path="*" element={<Navigate to="/login" replace />} /> {/* Redirect to login */}
            <Route path="*" element={<Navigate to="/" replace />} /> 
            {/* OR <Route path="*" element={<NotFoundPage />} /> */}

        </Routes>
    );
};

export default UnauthenticatedRoutes;